import { TextEditor } from '@iveco-ti/iveco-ds'
import { useTranslation } from 'react-i18next'

export function FormEditNewsContent() {
  const { t } = useTranslation('panel')

  return (
    <div className="h-full flex flex-col gap-6">
      <h2 className="text-2xl text-sky-700 font-semibold">
        {t('news.drawer_create_news.content.title')}
      </h2>

      <TextEditor.Root
        name="content"
        placeholder={t('news.drawer_create_news.fields.content.placeholder')}
      >
        <TextEditor.Toolbar>
          <TextEditor.ToolHeading />
          <TextEditor.ToolBold />
          <TextEditor.ToolItalic />
          <TextEditor.ToolUnderline />
          <TextEditor.ToolStrike />
          <TextEditor.ToolLink />
          <TextEditor.ToolOrderedList />
          <TextEditor.ToolBulletList />
          <TextEditor.ToolBlockquote />
          <TextEditor.ToolTextLeft />
          <TextEditor.ToolTextCenter />
          <TextEditor.ToolTextRight />
        </TextEditor.Toolbar>
      </TextEditor.Root>
    </div>
  )
}
